import { render, staticRenderFns } from "./BreakEvenKPM.vue?vue&type=template&id=c3544b6c"
import script from "./BreakEvenKPM.vue?vue&type=script&lang=js"
export * from "./BreakEvenKPM.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/websites/streamlined-business-solutions/sbs-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c3544b6c')) {
      api.createRecord('c3544b6c', component.options)
    } else {
      api.reload('c3544b6c', component.options)
    }
    module.hot.accept("./BreakEvenKPM.vue?vue&type=template&id=c3544b6c", function () {
      api.rerender('c3544b6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/reports/BreakEvenKPM.vue"
export default component.exports